import {OnlyInLoginChecker} from '../../../../../../common/checkers/OnlyInLoginChecker';
import {ScheduledLastPageFetcher} from '../../../../../../common/fetchers/ScheduledLastPageFetcher';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {LastViewInfo} from '../../../../../../graphql/generated/types';
import {MAX_PROGRESS_RATE} from '../constant/viewerConstant';
import {convertToLastViewRate} from '../util/convertToLastViewRate';

export interface TalkViewerProgressSyncContainerProps {
  seriesId: number;
  productId: number;
  lastViewInfo?: LastViewInfo;
}

/**
 * 톡뷰어 Progress 를 별도 스케쥴링에 의해 전송합니다
 * 사실 톡뷰어는 모든것이 redux-saga에 있기 때문에 이쪽에서 스케쥴링해도 무방하나 타 뷰어와의 일관성을 위해 ScheduledLastPageFetcher 를 사용했습니다
 * 단, 로딩 시 톡으로 이동하는 부분은 redux-saga 에서 처리합니다
 */
export function TalkViewerProgressSyncContainer({
  seriesId,
  productId,
}: TalkViewerProgressSyncContainerProps) {
  const talkViewerProgress = useTypedSelector(state => {
    return (
      state.talkViewer.productInfoMap[productId]?.progress || {
        totalTalkCount: 0,
        visitedTalkCount: 0,
      }
    );
  });
  const isViewerEndExposed = useTypedSelector(
    state => state.viewerEnd.isExposed
  );

  const rate = convertToLastViewRate({
    position: talkViewerProgress.visitedTalkCount,
    total: talkViewerProgress.totalTalkCount,
  });

  return (
    <OnlyInLoginChecker>
      {rate !== undefined && (
        <ScheduledLastPageFetcher
          seriesId={seriesId}
          productId={productId}
          rate={rate}
          spineIndex={isViewerEndExposed ? 1 : 0}
          isDone={rate === MAX_PROGRESS_RATE}
        />
      )}
    </OnlyInLoginChecker>
  );
}
